import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseEntity } from "../base.entity";
import { BrandBgEntityRaw } from "../../interface";
import { brandBgEntityRaw } from "../../schema";

export class BrandBgEntity extends BaseEntity<BrandBgEntityRaw> {
  private static validation = JsonSchemaValidator.compile(brandBgEntityRaw);

  constructor(value: BrandBgEntityRaw) {
    super(JsonSchemaValidator.assert(BrandBgEntity.validation, value));
  }
}
